export const props = () => [
    {
        key: 'url',
        label: '请求地址',
        type: 'string',
    },
    {
        key: 'method',
        label: '请求方式',
        type: 'enum',
        collection: [
            {
                label: 'GET',
                value: 'get',
            },
            {
                label: 'POST',
                value: 'post',
            },
        ],
    },
    {
        key: 'payloadSources',
        label: '参数来源',
        type: 'uuid-select',
        props: {
            multiple: true,
            apiOnly: false,
        },
    },
    {
        key: 'omitGlobalParams',
        label: '忽略路由/全局参数',
        type: 'boolean',
    },
    {
        key: 'config',
        label: '请求参数',
        type: 'object',
    },
    {
        key: 'preProcessCode',
        label: '发送前处理代码',
        type: 'string',
        props: {
            type: 'textarea',
            placeholder: '前端填写，可使用this, payload, url',
        },
    },
    {
        key: 'postProcessCode',
        label: '发送后处理代码',
        type: 'string',
        props: {
            type: 'textarea',
            placeholder: '前端填写，可使用this, res',
        },
    },
    {
        key: 'pickKey',
        label: '所需返回值',
        type: 'string',
        props: {
            placeholder: '不填表示所有返回数据',
        },
    },
];

export const init = () => ({
    url: '',
    method: 'post',
    payloadSources: [],
    omitGlobalParams: false,
    config: {},
    preProcessCode: '',
    postProcessCode: '',
    pickKey: 'data',
});

export const name = 'API';

export const component = 'mobile-general-form-api';

import { events as baseEvents } from '../component-base/props';
export const events = [
    'change',
    ...baseEvents,
];
